// Environment helpers for dashboard behavior
// Relies on Vite's import.meta.env.MODE and optional VITE_ENVIRONMENT override.
// Define VITE_ENVIRONMENT in .env files (e.g., local, dev, stage, prod) for explicit control.
export function getEnvironment() {
    const explicit = import.meta.env.VITE_ENVIRONMENT?.trim().toLowerCase();
    if (explicit === 'local' || explicit === 'dev' || explicit === 'stage' || explicit === 'prod')
        return explicit;
    // Fallback using mode heuristic
    const mode = import.meta.env.MODE;
    if (mode === 'development')
        return 'local';
    if (mode === 'production')
        return 'prod';
    return 'unknown';
}
export function canUseMockData() {
    const env = getEnvironment();
    return env === 'local' || env === 'dev';
}
export function shouldSendMock(mockFlag) {
    return !!mockFlag && canUseMockData();
}
